import { img } from "../lib/api";

export const hasFullViews = (p) => ["front", "back", "left", "right", "top"].every((k) => p.views?.[k]);

export default function MiniBox3D({ p }) {
  const { h = 100, w = 60, d = 50 } = p.dimensions || {};
  const k = 44 / Math.max(h, w, d);
  const H = h * k, W = w * k, D = d * k;
  const f = (fw, fh, t, src) => (
    <div className="absolute border border-black/30 bg-[#c9cbd1] overflow-hidden" style={{ width: fw, height: fh, left: (W - fw) / 2, top: (H - fh) / 2, transform: t }}>
      <img src={img(src)} alt="" className="w-full h-full object-cover" />
    </div>
  );
  const v = p.views;
  return (
    <div data-testid={`mini-3d-box-${p.id}`} className="absolute bottom-3 right-3 w-16 h-16 grid place-items-center rounded-xl bg-black/60 backdrop-blur border border-[#00f0ff]/40 [perspective:300px]">
      <div className="relative [transform-style:preserve-3d] mini-spin" style={{ width: W, height: H }}>
        {f(W, H, `translateZ(${D / 2}px)`, v.front)}
        {f(W, H, `rotateY(180deg) translateZ(${D / 2}px)`, v.back)}
        {f(D, H, `rotateY(90deg) translateZ(${W / 2}px)`, v.right)}
        {f(D, H, `rotateY(-90deg) translateZ(${W / 2}px)`, v.left)}
        {f(W, D, `rotateX(90deg) translateZ(${H / 2}px)`, v.top)}
      </div>
    </div>
  );
}
